(() => {
  angular
    .module('gm.common.directives')
    .directive('gmTimeoutClickButton', gmTimeoutClickButtonDirective);

  function gmTimeoutClickButtonDirective(
    $timeout,
    $interval
  ) {
    'ngInject';

    const DEFAULT_TIMEOUT = 60;

    function startBlockFormTimeout(scope) {
      const waitSec = scope.timeout;

      scope.isBlocked = true;
      scope.secondsLeft = waitSec;

      if (scope.blockTimeout) {
        $timeout.cancel(scope.blockTimeout);
      }

      if (scope.secondsLeftInterval) {
        $interval.cancel(scope.secondsLeftInterval);
      }

      scope.blockTimeout = $timeout(() => {
        scope.isBlocked = false;
      }, waitSec * 1000);

      scope.secondsLeftInterval = $interval(() => {
        scope.secondsLeft -= 1;
      }, 1000, waitSec);
    }

    return {
      restrict: 'E',
      scope: {
        timeout: '=?',
        action: '&',
        init: '@?'
      },
      templateUrl:
        'modules/common/directives/timeout-click-button/timeout-click-button.html',
      transclude: true,

      link(scope) {
        scope.isBlocked = false;
        scope.secondsLeft = 0;
        scope.timeout = scope.timeout || DEFAULT_TIMEOUT;

        scope.isVerifyLoading = false;
        scope.resendComplete = false;

        scope.doAction = () => {
          startBlockFormTimeout(scope);

          scope.isVerifyLoading = true;
          scope.resendComplete = false;
          scope.action()
            .then(() => {
              scope.resendComplete = true;
              $timeout(() => {
                scope.resendComplete = false;
              }, 3000);
            })
            .finally(() => {
              scope.isVerifyLoading = false;
            });
        };

        if (!scope.init) {
          startBlockFormTimeout(scope);
        }
      }
    };
  }
})();
